require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./member-kristine-jane-atienza.json") })
        }
      }, "path---member-kristine-jane-atienza");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---member-kristine-jane-atienza!./.cache/json/member-kristine-jane-atienza.json
// module id = 401
// module chunks = 231608221292675